import React from 'react';
import moment from 'moment';
import classNames from "classnames"

import "./exp-card.less"

function ExpCard(props) {
    const {
        desc = "",
        timeRange = moment(new Date()).format("YYYY-MM-DD"),
        color = "type1",
        tag = null
    } = props

    const cls = classNames(color)

    const tw = (desc.length + (tag && tag.length > 0 ? tag.length + 2 : 0)) * 14

    let dwEN = timeRange.length
    let dwCN = 0
    if (timeRange.indexOf("至") > -1) {
        dwEN--
        dwCN++
    }
    if (timeRange.indexOf("今") > -1) {
        dwEN--
        dwCN++
    }

    return (
        <span className={`exp-card-containt ${cls}`}>
            <div className="title" style={{ width: tw + "px" }}>
                {/* {
                    tag && tag.length > 0 && (
                        <span style={{ marginRight: "4px" }}>[{tag}]</span>
                    )
                } */}
                {desc}
            </div>
            <div style={{ width: (dwEN * 12 * 0.6 + dwCN * 12) + "px" }} className="date">{timeRange}</div>
        </span>
    );
}

export default ExpCard;